import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { OwnerModal } from './OwnerModal.component'

const withUnmountHoc = withUnmountTransition(OwnerModal)

export { withUnmountHoc as OwnerModal }
